import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import clsx from 'clsx'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from 'ui/components/tooltip'
import SvgIcon from '@material-ui/core/SvgIcon'
import { ReactComponent as IconProvider } from 'assets/icons/provider.svg'
import { ReactComponent as IconVerified } from 'assets/icons/verified.svg'
import { ReactComponent as IconDenied } from 'assets/icons/denied.svg'
import { ReactComponent as IconAdd } from 'assets/icons/add.svg'
import useStyles from './stylesItem'
import useTranslation from 'hooks/useTranslations'
import { getUserIsAdmin } from 'services/auth/selectors'

const Item = props => {
  const {
    id,
    isInMyNetwork,
    vendorId,
    title,
    isHomologated,
    onAddVendor,
    searchName,
  } = props

  const t = useTranslation()

  const classes = useStyles()

  const handleAddVendor = useCallback(() => {
    onAddVendor(id)
  }, [id, onAddVendor])

  const userIsAdmin = useSelector(getUserIsAdmin)

  return (
    <ListItem
      className={clsx(classes.root)}
      button
      component={Link}
      to={{
        pathname: `/app/vendors/${id || vendorId}`,
        state: {
          from: searchName ? 'savedSearch' : 'search',
          params: searchName ? { search: searchName } : {},
        },
      }}
      divider
      role="listitem"
      ContainerProps={{ className: classes.item }}
    >
      <ListItemText
        className={classes.itemText}
        disableTypography
        primary={
          <Typography className={classes.primary} variant="body2" noWrap>
            {title}
          </Typography>
        }
      />
      <ListItemSecondaryAction className={classes.itemActions}>
        {isHomologated ? (
          <Tooltip title={t('tooltip:homologate')} arrow placement="top">
            <IconButton
              className={clsx(classes.itemButton, classes.iconGold)}
              edge="end"
              aria-label="comments"
            >
              <SvgIcon className={classes.itemIcon} component={IconVerified} />
            </IconButton>
          </Tooltip>
        ) : (
          <Tooltip title={t('tooltip:no-homologate')} arrow placement="top">
            <IconButton
              className={clsx(classes.itemButton, classes.iconGrey)}
              edge="end"
              aria-label="comments"
            >
              <SvgIcon className={classes.itemIcon} component={IconDenied} />
            </IconButton>
          </Tooltip>
        )}

        {isInMyNetwork ? (
          <Tooltip title={t('filter:is-in-my-network')} arrow placement="top">
            <IconButton
              className={clsx(classes.itemButton, classes.iconLight)}
              edge="end"
              aria-label="comments"
            >
              <SvgIcon className={classes.itemIcon} component={IconProvider} />
            </IconButton>
          </Tooltip>
        ) : userIsAdmin ? (
          <Tooltip title={t('vendor:add')} arrow placement="top">
            <IconButton
              className={classes.iconMain}
              edge="end"
              aria-label="comments"
              onClick={handleAddVendor}
            >
              <SvgIcon className={classes.itemIconBig} component={IconAdd} />
            </IconButton>
          </Tooltip>
        ) : null}
      </ListItemSecondaryAction>
    </ListItem>
  )
}

Item.propTypes = {
  id: PropTypes.string,
  isInMyNetwork: PropTypes.bool,
  vendorId: PropTypes.string,
  title: PropTypes.string.isRequired,
  isHomologated: PropTypes.bool,
  onAddVendor: PropTypes.func,
  searchName: PropTypes.string,
}

export default Item
